// @ts-ignore
export const BUILD_INFO = {
    buildTime: import.meta.env.VITE_BUILD_TIME ?? null,
    commit: import.meta.env.VITE_GIT_COMMIT ?? null,
    branch: import.meta.env.VITE_GIT_BRANCH ?? null
};

export const FRONTEND_BOOT = {
    nonce: Math.random().toString(36).slice(2),
    bootTime: new Date().toISOString()
};
